import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApp } from "@/context/AppContext";
import { CASE_LABELS } from "@/constants/content";

export const CaseStudySelect = () => {
  const { caseStudies, activeSlug, setActiveSlug } = useApp();
  return (
    <div className="flex w-full min-w-0 items-center gap-2 sm:w-auto">
      <span className="hidden sm:inline text-xs text-slate-400 whitespace-nowrap">Active Case Study:</span>
      <Select value={activeSlug} onValueChange={setActiveSlug}>
        <SelectTrigger
          className="h-9 w-full sm:w-[290px] rounded-full [&>span]:truncate border-white/10 bg-white/[0.04] text-sm text-white focus:ring-cyan-400/50"
          data-testid="case-study-select-trigger"
          aria-label="Active case study"
        >
          <SelectValue placeholder="Loading case studies…" />
        </SelectTrigger>
        <SelectContent className="border-white/10 bg-[#0B1021] text-white">
          {caseStudies.map((cs) => (
            <SelectItem key={cs.slug} value={cs.slug} data-testid={`case-study-option-${cs.slug}`}>
              {cs.flag} {CASE_LABELS[cs.slug]?.label ?? cs.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
